import { createStore, applyMiddleware, compose } from 'redux';
import logger from 'redux-logger';
import thunk from 'redux-thunk';
import { routerMiddleware } from 'react-router-redux';
import promiseMiddleware from 'redux-promise-middleware';
import { browserHistory } from 'react-router';
import { createTracker } from 'redux-segment';
import { toastMiddleware, Socket } from '@ordermentum/ui-toast';
import { CONSTANTS, NOTIFICATION_EVENTS } from '../constants';

import rootReducer from '../reducers';

const tracker = createTracker();
const reduxRouterMiddleware = routerMiddleware(browserHistory);

const notifications = toastMiddleware(NOTIFICATION_EVENTS);
const promise = promiseMiddleware();

declare global {
  interface Window {
    __REDUX_DEVTOOLS_EXTENSION_COMPOSE__?: typeof compose;
  }
}

const middlewares = [
  thunk,
  promise,
  logger,
  reduxRouterMiddleware,
  tracker,
  notifications,
];

// eslint-disable-next-line no-underscore-dangle
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

if (process.env.NODE_ENV === 'development') {
  middlewares.push(logger);
}

const store = composeEnhancers(applyMiddleware(...middlewares))(createStore)(
  rootReducer,
  {}
);

if (process.env.WEBSOCKET_URL) {
  const socket = new Socket({
    url: process.env.WEBSOCKET_URL,
    store,
    C: CONSTANTS,
    opts: { delay: 5000 },
    experience: 'register',
  });
  socket.connect();
}

export type AppStore = typeof store;
export type RootState = ReturnType<AppStore['getState']>;

export default store;
